import {getIncompatibleRuleForFeatures} from "../utils/ruleFormatter";
import {CategoryType} from "../model/constants";
import IsNullOrUndefined from "../utils/ObjectUtils";
import {RulesUtility} from "./RulesUtility";

export const ImprovementRulesUtility = {
    isAvailableIfValidFor: (improvementRulesFound, categories, destinationCategory) => {
        let isAvailableIfValid = false;
        let availableIfCategory = null;
        const availableIfRules = improvementRulesFound.filter(r => r.ruleType === 'AVAILABLE_IF');

        availableIfRules.forEach(availableIfRule => {
            let originCategory = undefined;
            categories.forEach(category => {
                const foundFeature = category.features.find(feature => feature.id === availableIfRule.originId);
                if (foundFeature !== undefined){
                    originCategory = category;
                }

                if (originCategory !== undefined && foundFeature !== undefined){
                    if (originCategory.selected_feature === foundFeature.id) {
                        isAvailableIfValid = true;
                    } else {
                        availableIfCategory = originCategory;
                    }
                }
            });
        });

        if (availableIfRules.length === 0) isAvailableIfValid = true;

        if (!isAvailableIfValid && !IsNullOrUndefined(availableIfCategory)) {
            destinationCategory.availableIf = availableIfCategory.name;
        } else {
            destinationCategory.availableIf = null;
        }

        return isAvailableIfValid;
    },

    isIncompatibleWithValidFor: (improvementRulesFound, categories, destinationCategory) => {
        let isIncompatibleWithValid = true;
        let incompatibleWithFeatures = [];
        const incompatibleWithRules = improvementRulesFound.filter(r => r.ruleType === 'INCOMPATIBLE_WITH');

        incompatibleWithRules.forEach(incompatibleWithRule => {
            let originCategory = undefined;
            let originFeature = undefined;
            categories.forEach(category => {
                const foundFeature = category.features.find(feature => feature.id === incompatibleWithRule.originId);
                if (foundFeature !== undefined){
                    originCategory = category;
                    originFeature = foundFeature;
                }
            });

            if (originCategory !== undefined){
                if (originCategory.selected_feature === originFeature.id){
                    isIncompatibleWithValid = false;
                    incompatibleWithFeatures.push(originFeature);
                }
            }
        });

        if (!isIncompatibleWithValid) {
            destinationCategory.incompatibleWith = getIncompatibleRuleForFeatures(incompatibleWithFeatures);
        } else {
            destinationCategory.incompatibleWith = null;
        }

        return isIncompatibleWithValid;
    },

    applyImprovementRules: (improvementRules, rules, categories) => {
        categories.map(destinationCategory => {

            const improvementRulesFound = improvementRules.filter(improvementRule => improvementRule.destinationId === destinationCategory.id);

            if(improvementRulesFound.length > 0)
            {
                const isAvailableIfValid = ImprovementRulesUtility.isAvailableIfValidFor(improvementRulesFound, categories, destinationCategory);
                const isIncompatibleWithValid = ImprovementRulesUtility.isIncompatibleWithValidFor(improvementRulesFound, categories, destinationCategory);

                if (isAvailableIfValid && isIncompatibleWithValid) {
                    if (destinationCategory.selected_feature === 0) {
                        RulesUtility.findValidFeatureForCategory(rules, categories, destinationCategory);
                    }
                    // destinationCategory.selected_feature = destinationCategory.selected_feature !== 0 ? destinationCategory.selected_feature : destinationCategory.features[0].id;
                    destinationCategory.incompatibleWith = null;
                    destinationCategory.availableIf = null;
                } else {
                    destinationCategory.selected_feature = 0;
                }
            }
            else{
                destinationCategory.availableIf = null;
                destinationCategory.incompatibleWith = null;
            }
        });
    }
};
